// Utils
import equal from 'NewAngular/utils/equal/deep-equal';
/**
 * Returns true if the item is shared with other users.
 * @param item serialized shareable item
 */
export const isSharedWithOthers = (item) => {
    return item && item.sharing && item.sharing.is_owner && item.sharing.permission !== 'no_view';
};
export function isMinimalShareableItem(value) {
    return Object.prototype.hasOwnProperty.call(value, 'sharing') && equal(['type'], Object.keys(value.sharing));
}
